
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { PrivacyPolicyLink } from './privacyPolicyLink'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="p" components={components}>{`Ihre Privatsphäre ist uns wichtig. Diese Datenschutzerklärung informiert über die Daten, die wir für `}<MDXTag name="em" components={components} parentName="p">{`Wie populistisch sind Sie?`}</MDXTag>{` erheben.`}</MDXTag>
<MDXTag name="h2" components={components}>{`Erhebung von Daten`}</MDXTag>
<MDXTag name="p" components={components}>{`Wir erheben und speichern die folgenden Daten:`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Geschlecht des Benutzers/der Benutzerin (falls angegeben)`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Alter des Benutzers/der Benutzerin (falls angegeben)`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Ausbildung des Benutzers/der Benutzerin (falls angegeben)`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Newsportal, über das «Wie populistisch sind Sie?» besucht wurde`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Antworten zu den im Quiz gestellten Fragen auf einer Skala von −3`}{` `}{`bis`}{` `}{`3`}</MDXTag>
</MDXTag>
<MDXTag name="p" components={components}>{`Für die Benutzerstatistik wird die Software Google Analytics eingesetzt. Eine Verknüpfung der dort erhobenen Daten mit anderweitig erhobenen (einschliesslich der oben aufgeführten) Daten ist ausgeschlossen.`}</MDXTag>
<MDXTag name="h2" components={components}>{`Google Analytics`}</MDXTag>
<MDXTag name="p" components={components}>{`Die Verwendung von Google Analytics auf «Wie populistisch sind Sie?» entspricht derjenigen der Newsportale der Tamedia-Gruppe. Weitere Informationen dazu finden Sie in der `}<PrivacyPolicyLink/>{`.`}</MDXTag>
<MDXTag name="h2" components={components}>{`Verwendung der Daten`}</MDXTag>
<MDXTag name="p" components={components}>{`Wir verwenden die Antworten und damit verbundene Informationen des Benutzers für`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`die Berechnung der Distanz zu anderen Politikern innerhalb von «Wie populistisch sind Sie?»`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`die Visualisierung der kumulierten Positionen aller Benutzer(innen) innerhalb von «Wie populistisch sind Sie?»`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`eine statistische Analyse der Antworten in einem möglichen Folgeartikel`}</MDXTag>
</MDXTag>
<MDXTag name="p" components={components}>{`Alle Daten, welche so verwendet werden, sind anonym und werden nicht zu persönlichen Daten zugeordnet (z. B. indem die Daten mit Konten, Cookies, IP-Adressen oder ähnlich kombiniert werden).`}</MDXTag>
<MDXTag name="h2" components={components}>{`Kontakt`}</MDXTag>
<MDXTag name="p" components={components}>{`Falls Sie Fragen zu dieser Datenschutzerklärung oder zu unserem Umgang mit Ihren Daten haben, kontaktieren Sie bitte `}<MDXTag name="a" components={components} parentName="p" props={{"href":"mailto:interaktiv@tamedia.ch"}}>{`interaktiv@tamedia.ch`}</MDXTag>{`.`}</MDXTag>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  